<template>
  <div :class="['cart']" :style="styleObject">
    <transition name="fade">
      <div class="shimmer"></div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NewArrivalPlaceholder',
  data () {
    return {
    }
  },
  props: ['styleObject']
}
</script>

<style scoped>
.cart {
  position: relative;
  background-color: #FCEAE7; /* Background color of the cart */
  overflow: hidden; /* Ensure shimmer doesn't overflow */
  border-radius: 8px; /* Add rounded corners for a smoother look */
}

.shimmer {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.8) 50%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  50% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(100%);
  }
}

.cart-content {
  padding: 20px; /* Add some padding */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s ease-in-out;;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// ShimmerEffectPlaceHolder.vue?97cf240c